import React, { useMemo } from 'react';
import { FoClass } from '../../lib/types';
import { FO_PALETTE, FO_PRIVATE_CLASSES } from '../../lib/foColors';
import { LegendCard } from './LegendCard';
import { CategoricalLegend } from './CategoricalLegend';

interface FoMapLegendProps {
  // When true, all non-private classes (federal / state / local / tribal /
  // unknown) render at reduced opacity to match the private-timberland
  // focus mask painted on the map. Family + corporate stay at full
  // opacity. Off in free exploration.
  privateFocus?: boolean;
}

/**
 * Floating legend for the Forest Ownership map overlay. Colors match the
 * left-panel pie chart so a blue pixel on the map is the same Federal
 * ownership the blue pie slice counts. FO labels are long enough to wrap,
 * so the row uses a tighter `gap-x-3 gap-y-1` rhythm than the default.
 */
export const FoMapLegend: React.FC<FoMapLegendProps> = ({ privateFocus = false }) => {
  const dimKeys = useMemo<ReadonlySet<FoClass> | undefined>(() => {
    if (!privateFocus) return undefined;
    const privateSet = new Set<FoClass>(FO_PRIVATE_CLASSES);
    return new Set<FoClass>(FO_PALETTE.order.filter(k => !privateSet.has(k)));
  }, [privateFocus]);

  return (
    <LegendCard title="Forest ownership" positioned className="max-w-[440px]">
      <CategoricalLegend
        palette={FO_PALETTE}
        rowClassName="flex items-center gap-x-3 gap-y-1 flex-wrap"
        dimKeys={dimKeys}
      />
    </LegendCard>
  );
};
